import { loadLanguageAsync } from './index'

/**
 * Syncs the i18n locale with the user's language preference from the store
 * Call this after user login and on language change
 * @param {VueI18n} i18n - The VueI18n instance
 * @param {Vuex.Store} store - The Vuex store
 * @returns {Promise}
 */
export function syncLanguageWithStore (i18n, store) {
  var language = store.getters['auth/languagePreference'] || 'en'

  if (i18n.locale !== language) {
    return loadLanguageAsync(i18n, language)
  }

  return Promise.resolve()
}

/**
 * Changes language and saves to user profile and localStorage
 * @param {VueI18n} i18n - The VueI18n instance
 * @param {Vuex.Store} store - The Vuex store
 * @param {string} language - The language code to change to
 * @returns {Promise}
 */
export function changeLanguage (i18n, store, language) {
  localStorage.setItem('languagePreference', language)
  return loadLanguageAsync(i18n, language)
    .then(function () {
      return store.dispatch('auth/updateLanguagePreference', language)
    })
}

/**
 * Loads language from localStorage on app startup (before auth completes)
 * @param {VueI18n} i18n - The VueI18n instance
 * @returns {Promise}
 */
export function loadLanguageFromStorage (i18n) {
  var language = localStorage.getItem('languagePreference') || 'en'
  return loadLanguageAsync(i18n, language)
}
